import styles from "./About.module.css";
import { Typography, Button, TrustedBy } from "@grantyd/ui";
import frankie from "@/assets/images/frankie.png";
import YahooFinance from "@/assets/partners/yahoo-finance.png";
import BizTech from "@/assets/partners/biz-tech.png";
import NonProfitPro from "@/assets/partners/non-profit-pro.png";
import TheChronicleOfPhilanthropy from "@/assets/partners/the-chronicle-of-philanthropy.png";
import InvestorsHangout from "@/assets/partners/investors-hangout.jpg";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { aboutData } from "@/data/about";

const About = () => {
  const { header, content, cta } = aboutData;
  const trustedByImages = [
    { src: YahooFinance, alt: "Yahoo Finance" },
    { src: BizTech, alt: "BizTech" },
    { src: NonProfitPro, alt: "NonProfitPro" },
    { src: TheChronicleOfPhilanthropy, alt: "The Chronicle of Philanthropy" },
    { src: InvestorsHangout, alt: "Investors Hangout" },
  ];
  const isDesktop = useMediaQuery("(min-width: 768px)");

  return (
    <div className={styles.about}>
      <div className={styles.header}>
        <Typography
          as="h1"
          color="primary"
          variant={isDesktop ? "display-md" : "headline-lg"}
          style={{ fontWeight: "700" }}
        >
          {header.title}
        </Typography>
        <Typography as="p" color="primary" variant="body-lg">
          {header.description}
        </Typography>
      </div>
      <div className={styles.content}>
        <img src={frankie} alt="ceo" className={styles.contentImage} />

        <div className={styles.contentText}>
          <Typography as="p" color="primary" variant="body-lg">
            {content.mainText}
          </Typography>
          <Typography
            as="p"
            color="primary"
            variant="body-md"
            style={{ fontWeight: "700" }}
          >
            {content.ceoName}
          </Typography>
        </div>
      </div>

      <TrustedBy images={trustedByImages} title={false} />

      <div className={styles.ctaBox}>
        <div className={styles.ctaBoxContent}>
          <Typography as="h3" variant="headline-md" color="primary">
            {cta.title}
          </Typography>
          <Typography as="p" variant="body-lg" color="primary">
            {cta.description}
          </Typography>
        </div>
        <Button
          variant="primary"
          size="medium"
          style={{ width: "100%", maxWidth: "386px" }}
          onClick={() => {
            window.location.href = "/professional-services";
          }}
        >
          {cta.buttonText}
        </Button>
      </div>
    </div>
  );
};

export default About;
